import React, { useState } from "react";
import { Button } from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { useReportsStore } from "./store";
import { useToast } from "modules/navbar/top/store/toasterStore";
import { filterDate, isDownloadDisabled } from "modules/utilities/utility";

function DateInput({ tab }) {
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedDate, setSelectedDate] = useState(null);
  const { postReportsData } = useReportsStore();
  const { setToaster } = useToast();

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  const handleReports = () => {
    if (tab === "ACTIVE_CUSTOMER_REPORT") {
      postReportsData(
        {
          report: "ACTIVE_CUSTOMER_REPORT",
          meta: {
            startDate: moment(selectedDate).startOf("day").toISOString(),
            endDate: moment(selectedDate)
              .endOf("month")
              .endOf("day")
              .toISOString(),
          },
        },
        setToaster
      );
    } else {
      postReportsData(
        {
          report: tab,
          meta: {
            startDate: moment(startDate).startOf("day").toISOString(),
            endDate: moment(endDate).endOf("day").toISOString(),
          },
        },
        setToaster
      );
    }
  };

  return (
    <div className="d-flex flex-row gap-2">
      {tab === "ACTIVE_CUSTOMER_REPORT" ? (
        <div>
          <DatePicker
            selected={selectedDate}
            onChange={handleDateChange}
            dateFormat="MMMM"
            id="start_date_input"
            className="form-control"
            showMonthYearPicker
            filterDate={filterDate}
          />
        </div>
      ) : (
        <div className="d-flex gap-2">
          <div>
            <DatePicker
              selected={startDate}
              onChange={(date) => setStartDate(date)}
              formatWeekDay={(day) => day.slice(0, 3)}
              className="form-control"
              placeholderText="Select Date"
              maxDate={new Date()}
            />
          </div>
          <div>
            <DatePicker
              selected={endDate}
              onChange={(date) => setEndDate(date)}
              formatWeekDay={(day) => day.slice(0, 3)}
              className="form-control"
              placeholderText="Select Date"
              maxDate={new Date()}
            />
          </div>
        </div>
      )}
      <Button
        className={
          tab !== "ACTIVE_CUSTOMER_REPORT"
            ? startDate && endDate
              ? "btn-btn-primary"
              : "btn-btn-primary disabled"
            : selectedDate
            ? "btn-btn-primary"
            : "btn-btn-primary disabled"
        }
        onClick={handleReports}
        disabled={isDownloadDisabled}
      >
        Generate Report
      </Button>
    </div>
  );
}

export default DateInput;
